import { useState } from "react";
import LegacyPushNotificationForm from "../../../components/push-notification/LegacyPushNotificationForm";
import SectionHeader from "../../../components/section/SectionHeader";
import SectionTitle from "../../../components/section/SectionTitle";
import { BellAlertIcon } from "@heroicons/react/16/solid";
import FormModal from "../../../components/modal/FormModal";
import SentPushNotificationList from "../../../components/push-notification/SentPushNotificationList";

function SendPushNotification() {
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [notificationToReuse, setNotificationToReuse] = useState(null);

  const handleViewHistory = () => {
    setShowHistoryModal(true);
  };

  const handleReuseNotification = (notification) => {
    setNotificationToReuse(notification);
    setShowHistoryModal(false);
  };

  return (
    <>
      <div className="relative mb-6 flex w-full min-w-0 flex-col break-words rounded bg-white p-2 shadow-lg">
        <div className="rounded-t border-0 px-4 py-3 pb-8">
          <SectionHeader>
            <SectionTitle title="Push Notification" />
            <button
              className="flex items-center gap-2 text-primary justify-end mr-4"
              onClick={handleViewHistory}
            >
              <BellAlertIcon className="h-4 w-4" />
              <span className="text-sm font-medium">View History</span>
            </button>
          </SectionHeader>
        </div>
        <div className="m-4 mb-8 flex-auto bg-neutral-light p-4 py-8">
          <LegacyPushNotificationForm notification={notificationToReuse} />
        </div>
      </div>

      <FormModal
        hidden={!showHistoryModal}
        title={"Sent Push Notifications"}
        onDismiss={() => setShowHistoryModal(false)}
      >
        <SentPushNotificationList onUseNotification={handleReuseNotification} />
      </FormModal>
    </>
  );
}

export default SendPushNotification;
